// extracted by mini-css-extract-plugin
module.exports = {"message":"rVNK25LC","darkSuccess":"l481q_5Q"};